import { useAppDispatch, useAppSelector } from "@/lib/store.ts";
import {
  checkEmail,
  resendEmail,
  resetWizard,
  setStep,
} from "@/app/auth/signup/signup.components/wizard/wizard.slice.ts";
import { toast } from "sonner";

export function useWizard() {
  const dispatch = useAppDispatch();
  const wizard = useAppSelector((s) => s.signupWizard);
  const needsVerification = useAppSelector((s) => s.signup.needsVerification);

  const submitEmail = async (email: string) => await dispatch(checkEmail(email)).unwrap();

  const goto = (step: typeof wizard.step) => dispatch(setStep(step));
  const reset = () => dispatch(resetWizard());

  const resendConfirmationEmail = async () => {
    await dispatch(resendEmail(wizard.email as string));
    toast.success("Email sent successfully.");
  };

  return { ...wizard, submitEmail, goto, reset, resendConfirmationEmail, needsVerification };
}
